import {
  IReorderScenarioNodes,
  ISaveScenarioNode,
  IScenarioNode,
  IScenarioNodeTypes,
} from "../models/ILiveChatScenario";
import { configWithUserToken } from "../../services/config";

export const getScenarioTree = (includeInactive = true) =>
  configWithUserToken.get<IScenarioNode[]>(`LiveChatScenario?includeInactive=${includeInactive}`);

export const getScenarioNode = (nodeId: string) =>
  configWithUserToken.get<IScenarioNode>(`LiveChatScenario/${nodeId}`);

export const getScenarioTokens = () =>
  configWithUserToken.get<string[]>("LiveChatScenario/tokens");

export const getScenarioNodeTypes = () =>
  configWithUserToken.get<IScenarioNodeTypes>("LiveChatScenario/node-types");

export const createScenarioNode = (payload: ISaveScenarioNode) =>
  configWithUserToken.post<IScenarioNode>("LiveChatScenario", payload);

export const updateScenarioNode = (nodeId: string, payload: ISaveScenarioNode) =>
  configWithUserToken.put<IScenarioNode>(`LiveChatScenario/${nodeId}`, payload);

export const setScenarioNodeActive = (nodeId: string, isActive: boolean) =>
  configWithUserToken.patch(`LiveChatScenario/${nodeId}/active`, { isActive });

export const deleteScenarioNode = (nodeId: string, includeChildren: boolean) =>
  configWithUserToken.delete(`LiveChatScenario/${nodeId}?includeChildren=${includeChildren}`);

export const reorderScenarioNodes = (payload: IReorderScenarioNodes) =>
  configWithUserToken.post("LiveChatScenario/reorder", payload);
